// InfoCard.jsx
import React from "react";
import tool from "@/assets/tool";
import "./InfoCard.scss";
import { tutorial_tag } from "@/assets/jfData";
const findMatchedItems = (keysStr) => {
  const keys = keysStr.split(",").map((key) => key.trim()); // 将字符串分割成数组并去除空格
  const result = []; // 存放匹配结果
  tutorial_tag.forEach((parent) => {
    const matchedChildren =
      parent.children &&
      parent.children.filter((child) => keys.includes(child.key));
    if (matchedChildren && matchedChildren.length > 0) {
      matchedChildren.forEach((matchedChild) => {
        result.push({ ...matchedChild, parentTitle: parent.title }); // 可以添加 parentTitle 字段来标识父项
      });
    }
  });

  return result;
};
const InfoCard = ({ imageUrl, title, dec, author, reads, time, value }) => {
  const sectionStyle = {
    backgroundImage: `url(${value.cover})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "100% 100%",
  };
  const toDetail = (record) => {
    // 构建 URL 参数
    const params = new URLSearchParams({
      id: record.tutorialId,
      profilePictureUrl: record.profilePictureUrl,
      nickName: record.nickName,
    });
    const url = `/tutorial_detail?${params.toString()}`;
    window.open(url, "_blank"); // 在新窗口或新标签页中打开
  };
  const getlaBel = (v) => {
    let lab = findMatchedItems(v.label);
    const styleClasses = [
      "glow-text primary",
      "glow-text secondary",
      "cyber-text",
    ];

    return lab.map((v, index) => {
      // 循环使用样式类
      const styleClass = styleClasses[index % styleClasses.length];

      return (
        <span key={v.key} className={`lab ${styleClass}`}>
          {v.title}
        </span>
      );
    });
  };
  return (
    <div className="info-card" onClick={() => toDetail(value)}>
      <div className="image-container">
        <div
          style={sectionStyle}
          className={`mes_back_size ${imageUrl ? "" : "noBac"}`}
        >
          {/* 添加科技感文字层 */}
          <div className="tech-text-overlay">
            {getlaBel(value)}
            {/* <span className="glow-text primary">AI</span>
            <span className="glow-text secondary">FUTURE</span>
            <span className="cyber-text">TECH</span> */}
          </div>
        </div>
      </div>
      <div className="info-content">
        <div className="info-title">{title}</div>
        <div className="info-dec">{dec}</div>
        <div className="info-meta">
          <span className="author">
            <img
              src={`/file/${value.profilePictureUrl}`}
              alt={""}
              className="tx"
            />
            {value.nickName || tool.hideMiddleFour(value.phone)}
          </span>
          <span className="time">{time}</span>
        </div>
      </div>
    </div>
  );
};

export default InfoCard;
